import { Component, EventEmitter, Input, Output } from "@angular/core";
import { IFundingDetails } from "src/app/interfaces/member.interface";
import { NormalizeStringPipe } from "src/app/pipe/normalist-string.pipe";

@Component({
    templateUrl: './asset-card.component.html',
    selector: 'lok-asset-card',
    styleUrls: ['./asset-card.component.scss'],
    standalone: false
})
export class AssetCardComponent {
    @Input() asset!: any;
    @Input() index!: number;
    @Input() readOnly = false;
    @Output() editAsset = new EventEmitter();
    @Output() deleteAsset = new EventEmitter();
    @Input() livelihoodActivitiesData: any[] = [];


    edit () {
        this.editAsset.emit({ index: this.index });
    }

    delete () {
        this.deleteAsset.emit({ index: this.index });
    }
        getLabelByValue(value: string): string | null {
  for (const group of this.livelihoodActivitiesData) {
    const found = group.data.find((item:any) => item.value === value);
    if (found) {
      return found.label; // or found.enLabel if you want English label
    }
  }
  return null;
}
}
